import { IconProps } from '@/components/Icons'

const DataTransform = ({ title = 'Builder/ Operation/ Data_transform' }: IconProps) => (
  <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>{title}</title>
    <g id="Builder/-Operation/-Data_transform" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="transform" transform="translate(4.000000, 4.000000)" fill="#1A56DB" fillRule="nonzero">
        <path
          d="M41.5,-1.5 L9.40909091,-1.5 L9.40909091,30.5909091 L41.5,30.5909091 L41.5,-1.5 Z M38.5,1.5 L38.5,27.59 L12.409,27.59 L12.409,1.5 L38.5,1.5 Z"
          id="Rectangle"
        />
        <polygon id="Path" points="1.5 34.8636364 1.5 38.5 5.13636364 38.5 5.13636364 41.5 -1.5 41.5 -1.5 34.8636364" />
        <polygon
          id="Path"
          points="19.6818182 34.8636364 19.6818182 41.5 13.0454545 41.5 13.0454545 38.5 16.681 38.5 16.6818182 34.8636364"
        />
        <polygon
          id="Path"
          points="5.13636364 20.3181818 5.13636364 23.3181818 1.5 23.318 1.5 26.9545455 -1.5 26.9545455 -1.5 20.3181818"
        />
      </g>
    </g>
  </svg>
)

DataTransform.displayName = 'DataTransform'
export default DataTransform
